import { render, staticRenderFns } from "./contentBannerCreate.vue?vue&type=template&id=1b93c720&"
import script from "./contentBannerCreate.vue?vue&type=script&lang=js&"
export * from "./contentBannerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports